import { useRef } from "react";
import { ReactComponent as UploadIcon } from "../../../../../assets/icons/upload.svg";

const UploadButton = ({setFile,name,file}) => {
    let fileInput = useRef();

    function handleClick() {
        fileInput.current.click();
    }

    return (
        <div>
            <input
                ref={fileInput}
                onChange={(e) => {
                    if(e.target.files.length > 0) {
                        setFile(name,e.target.files[0]);
                    } else {
                        setFile(name,null);
                    }
                }}
                type="file"
                hidden
            />
            <button
                onClick={handleClick}
                type="button"
                className="btn btn-primary text-light d-flex align-items-center mt-3"
            >
                <UploadIcon className="me-2" />
                Upload
            </button>
            {file && <div>{file.name}</div>}
        </div>
    );
};

export default UploadButton;
